'use client'
import { SidebarGroupLabel } from "./ui/sidebar";
import { useI18n } from "@/contexts/lang-context";

export function SidebarPrincipalLabel() {
  const { t } = useI18n()
  return (
    <SidebarGroupLabel>{t("sidebar.platform")}</SidebarGroupLabel>
  )
}